import React, { useState } from "react";
import { toast } from "sonner";
import { api, getApiErrorMessage } from "../../lib/api";
import { PanelActionButton } from "./ContentPrimitives";

export const CONTENT_EDIT_FIELDS = {
  initiative: { endpoint: "initiatives", title: "nombre", body: "descripcion" },
  marketplace_post: { endpoint: "marketplace", title: "titulo", body: "descripcion" },
  event: { endpoint: "events", title: "nombre", body: "descripcion" },
  forum_question: { endpoint: "forum/questions", title: "titulo", body: "descripcion" },
  forum_answer: { endpoint: "forum/answers", body: "contenido" },
  library_document: { endpoint: "library", title: "titulo", body: "descripcion" },
};

export default function AdminContentEdit({ entityType, item, onSaved, onCancel, onFullEdit }) {
  const fields = CONTENT_EDIT_FIELDS[entityType];
  const [title, setTitle] = useState(item[fields.title] || "");
  const [body, setBody] = useState(item[fields.body] || "");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const submit = async (event) => {
    event.preventDefault();
    if (saving) return;
    setSaving(true);
    setError("");
    try {
      const payload = { [fields.body]: body.trim() };
      if (fields.title) payload[fields.title] = title.trim();
      await api.put(`/${fields.endpoint}/${item.id}`, payload);
      toast.success("Cambios guardados.");
      await onSaved();
    } catch (failure) {
      setError(getApiErrorMessage(failure, "No fue posible guardar los cambios."));
    } finally {
      setSaving(false);
    }
  };

  return (
    <form onSubmit={submit} className="mt-5 space-y-4 border-t border-primary/15 pt-5" aria-label="Editar publicación">
      {fields.title ? (
        <label className="block text-sm font-semibold text-primary">
          Título
          <input required minLength={3} maxLength={entityType === "initiative" || entityType === "marketplace_post" ? 200 : 300}
            value={title} onChange={(event) => setTitle(event.target.value)} disabled={saving}
            className="mt-2 w-full rounded-2xl border border-primary/20 p-3 font-normal" />
        </label>
      ) : null}
      <label className="block text-sm font-semibold text-primary">
        {entityType === "forum_answer" ? "Respuesta" : "Descripción"}
        <textarea value={body} onChange={(event) => setBody(event.target.value)} rows={5} disabled={saving}
          className="mt-2 w-full rounded-2xl border border-primary/20 p-3 font-normal" />
      </label>
      {error ? <p role="alert" className="text-sm text-[#8A3D22]">{error}</p> : null}
      <div className="flex flex-wrap gap-3">
        <PanelActionButton type="submit" disabled={saving}>{saving ? "Guardando..." : "Guardar cambios"}</PanelActionButton>
        <PanelActionButton tone="secondary" onClick={onCancel} disabled={saving}>Cancelar</PanelActionButton>
        {onFullEdit ? <PanelActionButton tone="secondary" onClick={onFullEdit} disabled={saving}>Editar todos los campos</PanelActionButton> : null}
      </div>
    </form>
  );
}
